<circ-loader [isLoading]="!isReady()"></circ-loader>
<circ-filter-group *ngIf="isReady()"
  [title]="'filterGroup_circulationList_title'"
  [actions]="filterActions"
  [isLoading]="isLoading$ | async"
  [selectedFilterId]="selectedFilterId"

  (filterClick)="onFilterClick($event)"
>
</circ-filter-group>
  <circ-grid *ngIf="isReady()" [data]="circulations$ | async" [showOutcome]="selectedFilterId=='Finished'" (cellClick)="onCellClick($event)"></circ-grid>
